/**
 * Intervallo di una sessione di chat per la riga in basso: "09:15", "15:30 – 16:42",
 * "ieri 22:41 – 08:12". Modulo puro, senza React ne' client Supabase, cosi' i test
 * non trascinano l'albero della card.
 */
import { formatCompactDate, formatTime } from './cardStyles';

export function sameCalendarDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/** Prefisso relativo del giorno di inizio ("oggi"/"ieri"/data compatta). */
export function relativeDayLabel(date: Date, now: Date): string {
  if (sameCalendarDay(date, now)) return 'oggi';
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (sameCalendarDay(date, yesterday)) return 'ieri';
  return formatCompactDate(date, now);
}

/** Intervallo della sessione per l'header della card. */
export function formatSessionRange(startAt: string, endAt: string, now: Date = new Date()): string {
  const start = new Date(startAt);
  const end = new Date(endAt);
  if (start.getTime() === end.getTime()) return formatTime(end);
  if (sameCalendarDay(start, end)) return `${formatTime(start)} – ${formatTime(end)}`;
  return `${relativeDayLabel(start, now)} ${formatTime(start)} – ${formatTime(end)}`;
}
